export default __webpack_public_path__ + "static/media/templateProgress.aab6cdbf.webp";